export default (color = '') => {
  if (color && color.match(/^#([0-9a-f]{3}){1,2}$/i)) {
    return true
  }
  return false
}
